<template>
  <AkParagraph class="ds-text-neutral-900 ds-py-2">
    {{ currentFilter.label }}
    <AkIcon
      v-if="currentFilter.icon"
      :symbol="currentFilter.icon"
      class="list-widget__icon"
    />
  </AkParagraph>
  <AkField
    class="ds-px-3"
    :label="currentFilter.subLabel"
  >
    <AkDatePicker
      ref="datePicker"
      :preset-dates="presetDates"
      range
      :model-value="currentValues"
      :placeholder="currentFilter.placeholder"
      :select-text="$t('Apply')"
      :cancel-text="$t('Cancel')"
      @update:model-value="setValue"
    />
  </AkField>
</template>
<script lang="ts">
import {defineComponent, PropType, ref, computed} from 'vue';
import {AkDatePicker, AkField, AkIcon, AkParagraph} from "@ankorstore/design-system";
import {
  ContactFilterType, RangeContactFilter,
} from "@bc/brands/domain/contact-management/types/api.types";
import {DateRangeWidgetComponent} from "@bc/brands/domain/contact-management/types/filter.types";

export default defineComponent({
  name: "DateRangeWidget",
  components: {AkField, AkDatePicker, AkParagraph, AkIcon},
  props: {
    filter: {
      type: Object as PropType<DateRangeWidgetComponent>,
      required: true,
    },
    modelValue: {
      type: Object as PropType<RangeContactFilter>,
      default: () => ({}),
    },
  },
  emits: ['update:modelValue'],
  setup(props, {emit}) {
    const currentFilter = ref(props?.filter);
    const currentValues = computed(() : Date[] => {
      return [props.modelValue.min as Date, props.modelValue.max as Date];
    });
    const setValue = (value?: string[]) => {
      emit('update:modelValue', {
        type: ContactFilterType.Range,
        name: props.filter.attributeName,
        min: value ? value[0] : '',
        max: value ? value[1] : '',
        dataType: 'date'
      });
    };

    const presetDates = props.filter.values?.map((item) => {
      return {
        label: item.label,
        value: [item.from, item.to],
      };
    });

    return {setValue, currentFilter, presetDates, currentValues};
  }
})
</script>
